import React from "react";
import {
  PanelRow,
  PanelSubheading,
  Link,
  Label,
  PanelDialog,
  PanelHeading,
  TextInput,
  PanelActions,
  Button,
} from "@backslashbuild/pp-ui/dist/index.es";
import { useGet, usePost } from "./api";
import { isTextNullOrEmpty } from "./utils";
import { publish } from "./pubSub";

export default function GroupOverridePanelRow({ accountNumber }) {
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [value, setValue] = React.useState("");
  const { data, loading, error, refetch } = useGet("employments/employment/" + accountNumber);

  const update = usePost("employments/update-group-override");

  async function handleSubmit() {
    try {
      const response = await update({ accountNumber, groupOverride: value });

      if (response.isSuccess) {
        publish("notification", "Updated successfully");
        setDialogOpen(false);
        refetch();
      } else {
        publish(
          "notification",
          <div>
            Unable to update employment
            <ul>
              {response.errors.map((error) => (
                <li>{error}</li>
              ))}
            </ul>
          </div>
        );
      }
    } catch (e) {
      console.error(e, "error updating");
      publish("notification", "A network error occured.");
    }
  }

  return (
    <>
      <PanelSubheading
        rightAction={
          <Link component={Link} onClick={() => setDialogOpen(true)}>
            Edit
          </Link>
        }
      >
        NEST Group
      </PanelSubheading>
      <PanelRow>
        <Label label="Override">
          {isTextNullOrEmpty(data?.value?.groupOverride)
            ? "No override"
            : data?.value?.groupOverride}
        </Label>
      </PanelRow>
      <PanelDialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <PanelHeading>Edit Group Override</PanelHeading>
        <PanelRow>
          <Label label="Group Override">
            <TextInput value={value} onChange={(e) => setValue(e.target.value)} />
          </Label>
        </PanelRow>
        <PanelActions>
          <Button variant="secondary" onClick={() => setDialogOpen(false)}>
            Cancel
          </Button>
          <Button onClick={() => handleSubmit()}>Submit</Button>
        </PanelActions>
      </PanelDialog>
    </>
  );
}
